const ACCOUNT_SELECTION_RETURN_URL = "accountSelectionReturnUrl";

export const saveAccountSelectionReturnUrl = () => {
  const returnUrl = `${window.location.pathname}${window.location.search}${window.location.hash}`;
  window.sessionStorage.setItem(ACCOUNT_SELECTION_RETURN_URL, returnUrl);
};

export const consumeAccountSelectionReturnUrl = () => {
  const returnUrl = window.sessionStorage.getItem(ACCOUNT_SELECTION_RETURN_URL);
  window.sessionStorage.removeItem(ACCOUNT_SELECTION_RETURN_URL);
  return returnUrl;
};
